/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import useForm from '../../hooks/useForm';
import { deleteExternalProfiles, getExternalProfiles } from '../../apis/externalProfile';
import { ControlTable } from '../Table';
import TaxConsultingCompanyModal from '../../pages/TaxPortal/TaxConsulting/TaxConsultingCompanyModal';
import { isEmpty } from '../../utils/lodashExtend';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';



const ExternalProfiles = () => {
  const { employee } = useSelector(
    (store) => ({
      employee: store.Profile.employee,
    }),
    shallowEqual
  );

  const [mode, setMode] = useState("create");

  const [fields] = useState([
    { title: "이름", key: "name" },
    { title: "회사명", key: "companyName" },
    {
      title: "프로필 종류", key: "isMain",
      onValue: (v) => v ? "메인 프로필" : "서브 프로필"
    },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      label: "수정",
      onClick: ({ data }) => {
        setIsDetailOpen(true);
        setMode("modify");
        setSelectedItem({
          ...data,
        });
      },
    },
  ]);

  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const submit = () => {
    getExternalProfiles(employee.employeeIdx || employee.idx)
      .then(res => {
        setList(res);
      })
      .finally(() => setIsLoading(false));
  };


  const {
    form,
    setSubmit,
    // handleSubmit,
    // LIST 용
    list, setList,
    isLoading, setIsLoading,
    selectedList, setSelectedList,
    reSubmit,
  } = useForm();

  useEffect(() => {
    if (employee) {
      setIsLoading(true);
      submit(form);
      setSubmit(submit);
    }
  }, [employee]);

  const tableButtons = [{
    label: "삭제하기",
    color: "red",
    onClick: () => {
      systemAlert(
        `${selectedList[0].name}${selectedList.length > 1 ? ` 외 ${selectedList.length - 1}개` : ""}의 프로필을 정말 삭제하시겠습니까?`,
        {
          buttons: [
            {
              label: "취소",
              color: "text"
            },
            {
              label: "삭제",
              color: "red",
              onClick: () => {
                deleteExternalProfiles({ idxes: selectedList.map(item => item.idx) })
                  .then(res => {
                    toast.success("삭제가 완료되었습니다.");
                    reSubmit();
                  });
              }
            }
          ]
        }
      );
    },
    disabled: isEmpty(selectedList)
  }, {
    label: "등록하기",
    onClick: () => {
      setIsDetailOpen(true);
      setMode("create");
    }
  }];

  return (
    <>
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isControl={true}
        buttons={tableButtons}
      />

      <TaxConsultingCompanyModal
        isOpen={isDetailOpen}
        setIsOpen={setIsDetailOpen}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        orgMode={mode}
        submit={reSubmit}
      />

    </>
  );
};

export default ExternalProfiles;